import { render } from "./IconDelete.vue?vue&type=template&id=0fce6338"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconDelete.vue"]])

export default __exports__